module.exports = __webpack_public_path__ + "public/img/3c_code.e7ab20e8.png";